import Immutable from 'immutable';
import uuid from '../utils/uuid';
import { createMigration } from './utils';

export const migrationTo9_152 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            const sceneIds = map.get('slides').map((scene: Immutable.Map<string, any>) => scene.get('id'));
            // Add a new scene group for every existing scene
            const sceneGroupList = sceneIds.map((sceneId: string) => (Immutable.fromJS({
                id: uuid(),
                sceneIds: [sceneId],
            })));
            map.set('sceneGroups', sceneGroupList);
        });
    },
});
